// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop({ children }: { children?: React.ReactNode }) {
  const { pathname } = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
    // 1. Try window scrolling
    window.scrollTo(0, 0);
    
    // 2. Try document container scrolling (Fixes mobile emulator overrides)
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }, 50); // Small 50ms delay gives the device emulator time to paint

  return () => clearTimeout(timer);
  }, [pathname]);

  return children ? <>{children}</> : null;
}